import { render, staticRenderFns } from "./PendingAndUserNotModifiedGroup.vue?vue&type=template&id=10e88220"
import script from "./pendingAndUserNotModifiedGroup.ts?vue&type=script&lang=ts&external"
export * from "./pendingAndUserNotModifiedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports